import { GroupTypeEnum, GroupUserRoleEnum } from '@bondsports/types';

export { GroupTypeEnum, GroupUserRoleEnum };

/**
 * Roles that grant primary-capable privileges (billing eligibility, admin checks).
 */
export const PRIMARY_GROUP_USER_ROLES: readonly GroupUserRoleEnum[] = [
	GroupUserRoleEnum.PRIMARY,
	GroupUserRoleEnum.ADMIN,
	GroupUserRoleEnum.FINANCE,
	GroupUserRoleEnum.MANAGER,
] as const;

/**
 * Non-primary group-account roles (dependents / staff).
 */
export const NON_PRIMARY_GROUP_USER_ROLES: readonly GroupUserRoleEnum[] = [
	GroupUserRoleEnum.DEPENDENT,
	GroupUserRoleEnum.STAFF,
] as const;

export const BUSINESS_GROUP_USER_ROLES: readonly GroupUserRoleEnum[] = [
	GroupUserRoleEnum.ADMIN,
	GroupUserRoleEnum.FINANCE,
	GroupUserRoleEnum.MANAGER,
	GroupUserRoleEnum.STAFF,
] as const;

export const FAMILY_GROUP_USER_ROLES: readonly GroupUserRoleEnum[] = [
	GroupUserRoleEnum.PRIMARY,
	GroupUserRoleEnum.DEPENDENT,
] as const;

/**
 * True when the group-account role is primary-capable.
 */
export function isPrimaryGroupUserRole(userRole: GroupUserRoleEnum | undefined | null): boolean {
	return userRole != null && PRIMARY_GROUP_USER_ROLES.includes(userRole);
}

/**
 * True when the group-account role is non-primary (dependent or staff).
 */
export function isNonPrimaryGroupUserRole(userRole: GroupUserRoleEnum | undefined | null): boolean {
	return userRole != null && NON_PRIMARY_GROUP_USER_ROLES.includes(userRole);
}

/**
 * True when the customer-facing role is explicitly independent.
 */
export function isIndependentGroupUserRole(userRole: GroupUserRoleEnum | undefined | null): boolean {
	return userRole === GroupUserRoleEnum.INDEPENDENT;
}

/**
 * True when the customer belongs to a group account (has a stored group role).
 */
export function isGroupMemberUserRole(userRole: GroupUserRoleEnum | undefined | null): boolean {
	return !!userRole && userRole !== GroupUserRoleEnum.INDEPENDENT;
}
